document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("switch-store-popup");
  if (!popup) return;

  const closeBtn = popup.querySelector(".popup-close");

  const STORAGE_KEY = "newsletterPopupShown";
  const SHOW_DELAY = 1000;
  const params = new URLSearchParams(window.location.search);

  if (params.get("switched") === "true") {
    localStorage.setItem(STORAGE_KEY, "true");
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  const showPopup = () => {
    window.scrollTo(0, 0);
    popup.classList.add("active");
  };

  const hidePopup = () => {
    popup.classList.remove("active");
    localStorage.setItem(STORAGE_KEY, "true");
    const newsletterPopup = document.getElementById("newsletter-popup");
    newsletterPopup.classList.add("active");
  };

  if (closeBtn) {
    closeBtn.addEventListener("click", hidePopup);
  }

  const activeSwitch = popup.querySelector(".switch-store__item.active");

  if (activeSwitch) {
    activeSwitch.addEventListener("click", (e) => {
      e.preventDefault();
      hidePopup();
    });
  }

  const alreadyShown = localStorage.getItem(STORAGE_KEY);
  if (!alreadyShown) {
    setTimeout(showPopup, SHOW_DELAY);
  }
});

// ?customer_posted=true
